export default "__VITE_ASSET__Crm$vT9d__"